export default {
	props: {
		modelValue: {
			type: String, 
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		}
	},
}